import MicroDepositInfoModal from "./MicroDepositInfoModal";

export default MicroDepositInfoModal;
